import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/globals.css';
import { App } from '@/app/App';
import { registerChunkErrorRecovery, startVersionWatcher } from '@/app/version';
import { installRealSession } from '@/app/session';

registerChunkErrorRecovery();
startVersionWatcher();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

/**
 * The session and workspace stores are read SYNCHRONOUSLY by route guards, so
 * they must be populated before the router renders its first match. Awaited
 * here rather than inside the tree: a guard that resolved after first paint
 * would let one frame of the wrong screen through.
 *
 * The session is READ FROM THE SERVER. There is no development stub and no
 * seeded user: the application believes in a session only when the platform says
 * so. The loader is installed here rather than awaited here — the guards call
 * `bootstrapSession()` themselves, and it shares one in-flight request between
 * them, so installing the loader is enough and pre-fetching would be a second
 * request for the same answer.
 */
installRealSession();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
